// src/hooks/useAutomationPerformance.js
import { useEffect, useState } from 'react';
import { getAutomationPerformance } from '../api/automations';

export const useAutomationPerformance = (automationId) => {
  const [performance, setPerformance] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!automationId) {
      setIsLoading(false);
      return;
    }

    const fetchPerformance = async () => {
      setIsLoading(true);
      try {
        const data = await getAutomationPerformance(automationId);
        setPerformance(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching automation performance:', err);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPerformance();
  }, [automationId]);

  return { performance, error, isLoading };
};